import { useState, useEffect } from 'react';
import firebase from 'firebase/app';

/**
 * Data source for Ops → Integrations: the ops/integrations doc, live —
 * ONE doc, every setting a flat field. Reads are a direct subscription
 * (ops/** is admin-read-only by rules); writes go through the admin
 * callable, the only write path to browser-unwritable ops/**.
 *
 * Shape (house convention): [loading, integrations, error, intents].
 * integrations is null while loading and {} when the doc doesn't exist yet.
 */
export function useIntegrations() {
    const [state, setState] = useState({ loading: true, integrations: null, error: null });

    useEffect(() => firebase.firestore()
        .collection('ops').doc('integrations')
        .onSnapshot(
            (snap) => setState({
                loading: false,
                integrations: snap.exists ? (snap.data() || {}) : {},
                error: null,
            }),
            (err) => {
                console.warn('[useIntegrations] listen failed:', err && err.message);
                setState({ loading: false, integrations: null, error: err.message || 'Could not load integrations' });
            },
        ), []);

    /** Admin intent: set (or clear, with null/blank) one flat field. */
    const setIntegrationField = async (field, value) => firebase.functions()
        .httpsCallable('integrationService-settingsHandler-adminSetField')({ field, value });

    return [state.loading, state.integrations, state.error, { setIntegrationField }];
}

export default useIntegrations;
